/**
 * Fair Housing Icon
 * 
 * The Fair Housing logo indicating compliance with fair housing laws.
 * Includes "EQUAL HOUSING OPPORTUNITY" text.
 */

import type { IconProps } from '../../types';

export function FairHousingIcon({ 
  className, 
  size = 40, 
  color = 'currentColor',
  'aria-label': ariaLabel = 'Fair Housing',
  ...props
}: IconProps) {
  return (
    <svg 
      className={className}
      width={size} 
      height={typeof size === 'number' ? size * 0.96 : size}
      viewBox="0 0 40 38.4"
      fill={color}
      aria-label={ariaLabel}
      role="img"
      {...props}
    >
      <path d="M19.9,0L0,9.9v3h2.9v16H37v-16h3v-3L19.9,0z M33,24.9H7V11.4L19.9,5L33,11.4V24.9z M13,15.7h14v-4.1H13V15.7z M13,21.7h14v-4.1H13V21.7z" />
      <g>
        <path d="M3,31.2h2.2v0.6H3.7v0.4H5v0.6H3.7v0.4h1.5V34H3V31.2z" />
        <path d="M7.8,33.8C7.5,33.9,7.2,34,6.9,34c-0.8,0-1.5-0.6-1.5-1.4v0c0-0.8,0.6-1.4,1.5-1.4s1.5,0.6,1.5,1.4v0c0,0.3-0.1,0.6-0.2,0.8l0.3,0.2l-0.4,0.4L7.8,33.8z M7.2,33.3L6.8,33l0.4-0.4l0.4,0.3c0-0.1,0-0.2,0-0.3v0c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v0c0,0.4,0.3,0.7,0.7,0.7C7,33.4,7.1,33.3,7.2,33.3z" />
        <path d="M8.8,32.8v-1.5h0.8v1.5c0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.5-0.2,0.5-0.6v-1.5h0.8v1.5c0,0.9-0.5,1.3-1.3,1.3C9.2,34,8.8,33.6,8.8,32.8z" />
        <path d="M12.6,31.2h0.7l1.2,2.8h-0.8l-0.2-0.5h-1.1L12.2,34h-0.8L12.6,31.2z M13.3,32.9L13,32.1l-0.3,0.8H13.3z" />
        <path d="M14.8,31.2h0.8v2.1h1.3V34h-2.1V31.2z" />
        <path d="M18.3,31.2H19v1h1v-1h0.8V34H20v-1h-1v1h-0.8V31.2z" />
        <path d="M21.1,32.6L21.1,32.6c0-0.8,0.6-1.4,1.5-1.4s1.5,0.6,1.5,1.4v0c0,0.8-0.6,1.4-1.5,1.4C21.8,34,21.1,33.4,21.1,32.6zM23.3,32.6L23.3,32.6c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v0c0,0.4,0.3,0.7,0.7,0.7C23,33.4,23.3,33,23.3,32.6z" />
        <path d="M24.4,32.8v-1.5h0.8v1.5c0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.5-0.2,0.5-0.6v-1.5H27v1.5c0,0.9-0.5,1.3-1.3,1.3C24.9,34,24.4,33.6,24.4,32.8z" />
        <path d="M27.2,33.6l0.4-0.5c0.3,0.2,0.6,0.3,0.9,0.3c0.2,0,0.3-0.1,0.3-0.2v0c0-0.1-0.1-0.2-0.5-0.3c-0.6-0.1-1-0.3-1-0.9v0c0-0.5,0.4-0.9,1.1-0.9c0.5,0,0.8,0.1,1.1,0.4l-0.4,0.5c-0.3-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.3,0.1-0.3,0.2v0c0,0.1,0.1,0.2,0.5,0.3c0.6,0.1,1,0.3,1,0.9v0c0,0.6-0.4,0.9-1.1,0.9C28,34,27.6,33.9,27.2,33.6z" />
        <path d="M30,31.2h0.8V34H30V31.2z" />
        <path d="M31.3,31.2H32l1.1,1.4v-1.4h0.8V34h-0.7L32,32.5V34h-0.8V31.2z" />
        <path d="M34.3,32.6L34.3,32.6c0-0.8,0.6-1.4,1.5-1.4c0.5,0,0.8,0.1,1.1,0.4l-0.4,0.5c-0.2-0.2-0.4-0.3-0.7-0.3c-0.4,0-0.7,0.3-0.7,0.8v0c0,0.4,0.3,0.8,0.7,0.8c0.2,0,0.3,0,0.4-0.1v-0.3h-0.5v-0.6h1.3v1.2c-0.3,0.2-0.7,0.4-1.2,0.4C34.9,34,34.3,33.5,34.3,32.6z" />
        <path d="M2.9,36.8L2.9,36.8c0-0.9,0.7-1.6,1.7-1.6c1,0,1.7,0.7,1.7,1.6v0c0,0.9-0.7,1.6-1.7,1.6S2.9,37.7,2.9,36.8z M5.4,36.8L5.4,36.8c0-0.5-0.3-0.9-0.8-0.9c-0.5,0-0.8,0.4-0.8,0.8v0c0,0.5,0.3,0.8,0.8,0.8C5.1,37.7,5.4,37.3,5.4,36.8z" />
        <path d="M6.7,35.2h1.3c0.8,0,1.3,0.4,1.3,1.1v0c0,0.7-0.6,1.1-1.4,1.1H7.6v0.9H6.7V35.2z M8,36.8c0.3,0,0.5-0.2,0.5-0.4v0C8.5,36.1,8.3,36,8,36H7.6v0.8H8z" />
        <path d="M9.8,35.2h1.3c0.8,0,1.3,0.4,1.3,1.1v0c0,0.7-0.6,1.1-1.4,1.1h-0.4v0.9H9.8V35.2z M11.1,36.8c0.3,0,0.5-0.2,0.5-0.4v0c0-0.3-0.2-0.4-0.5-0.4h-0.4v0.8H11.1z" />
        <path d="M12.7,36.8L12.7,36.8c0-0.9,0.7-1.6,1.7-1.6c1,0,1.7,0.7,1.7,1.6v0c0,0.9-0.7,1.6-1.7,1.6S12.7,37.7,12.7,36.8z M15.2,36.8L15.2,36.8c0-0.5-0.3-0.9-0.8-0.9c-0.5,0-0.8,0.4-0.8,0.8v0c0,0.5,0.3,0.8,0.8,0.8C14.9,37.7,15.2,37.3,15.2,36.8z" />
        <path d="M16.5,35.2H18c0.5,0,0.8,0.1,1,0.3c0.2,0.2,0.3,0.4,0.3,0.7v0c0,0.5-0.3,0.8-0.6,1l0.7,1.1h-1l-0.6-1h0h-0.4v1h-0.9V35.2zM18,36.8c0.3,0,0.5-0.1,0.5-0.4v0c0-0.2-0.2-0.4-0.5-0.4h-0.6v0.8H18z" />
        <path d="M20.5,36h-0.9v-0.8h2.8V36h-0.9v2.4h-0.9V36z" />
        <path d="M22.7,37v-1.8h0.9V37c0,0.5,0.2,0.7,0.6,0.7c0.4,0,0.6-0.2,0.6-0.6v-1.8h0.9V37c0,1-0.6,1.5-1.5,1.5S22.7,38,22.7,37z" />
        <path d="M26.2,35.2H27l1.3,1.7v-1.7h0.9v3.1h-0.8L27,36.7v1.7h-0.9V35.2z" />
        <path d="M29.7,35.2h0.9v3.1h-0.9V35.2z" />
        <path d="M31.9,36H31v-0.8h2.8V36h-0.9v2.4h-0.9V36z" />
        <path d="M35,37.2l-1.2-2h1l0.6,1.1l0.7-1.1h1l-1.2,2v1.2H35V37.2z" />
      </g>
    </svg>
  );
}

